import { useAppContext } from '@features/contexts/AppProvider';
import { VerticalBar } from './VerticalBar';
import { HorizontalBar } from './HorizontalBar';

type DataBarProps = {
  verticalView: boolean;
  color: string;
  borderColor: string;
  baseline: number;
  value: number;
  max: number;
  label?: string;
  showLabel?: boolean;
  showValue?: boolean;
  maxVerticalBarHeight?: number;
  cardView?: boolean;
};

export const DataBar = ({
  maxVerticalBarHeight,
  verticalView,
  color,
  borderColor,
  baseline,
  value,
  label,
  max,
  showLabel,
  showValue,
  cardView,
}: DataBarProps) => {
  const {
    chartConfig: {
      barChart: { showMaxValueIndicator, showBarDiff },
    },
  } = useAppContext();

  return verticalView ? (
    <VerticalBar
      maxBarSize={maxVerticalBarHeight}
      color={color}
      borderColor={borderColor}
      baseline={baseline}
      value={value}
      label={label}
      max={max}
      showLabel={showLabel}
      showValue={showValue}
      cardView={cardView}
      showMaxValueIndicator={showMaxValueIndicator}
      showBarDiff={showBarDiff}
    />
  ) : (
    <HorizontalBar color={color} baseline={baseline} value={value} max={max} />
  );
};
